import React, { Component } from "react";
import { connect } from "react-redux";
import { setMatchingQuestionResponse } from "./store/actions";
import { FormattedMessage, injectIntl } from "react-intl";

import "./styles.scss";

class MatchingQuestion extends Component {
  updateComponent = (type, index, label) => {
    this.props.setMatchingQuestionResponse({
      type: type,
      value: index,
      label: label,
    });
  };

  renderOptions = (options, questionIndex, type) => {
    const { intl } = this.props;

    return (
      <div className="predictionsChoiceQuestion">
        <div className="predictionsChoiceQuestion-inner-wrap">
          {options.map((option, index) => (
            <div className="option" key={index}>
              <div className="input">
                <input
                  id={`scq${questionIndex}${index}`}
                  className={
                    option.correct == null
                      ? ""
                      : option.correct
                        ? "correct"
                        : "incorrect"
                  }
                  type="radio"
                  name={`answer-${type}-${index}`}
                  value={index}
                  onChange={() =>
                    this.updateComponent(type, index, option.label)
                  }
                  checked={index === this.props[`selected_${type}`]}
                  tabIndex={-1}
                />
                <label
                  role="presentation"
                  aria-label={
                    (this.props[`selected_${type}`] === index
                      ? intl.formatMessage({
                          id: this.props.component_strings.selected,
                          defaultMessage: this.props.component_strings.selected,
                          description: "",
                        })
                      : "") +
                    intl.formatMessage({
                      id: option.label,
                      defaultMessage: option.label,
                      description: "",
                    })
                  }
                  onClick={() =>
                    this.updateComponent(type, index, option.label)
                  }
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      this.updateComponent(type, index, option.label);
                    }
                  }}
                  htmlFor={`scq${questionIndex}${index}`}
                  className="response"
                  style={
                    option.image
                      ? {
                          display: "flex",
                          alignItems: "center",
                          padding: "19px 7.5px",
                        }
                      : { padding: "19px 7.5px" }
                  }
                >
                  {option.image && (
                    <div className="image-wrapper">
                      <img
                        src={require(`./img/${option.image}`).default}
                        alt={intl.formatMessage({
                          id: option.ariaLabel,
                          defaultMessage: option.ariaLabel,
                          description: "",
                        })}
                      />
                    </div>
                  )}
                  <FormattedMessage
                    id={option.label}
                    defaultMessage={option.label}
                    description=""
                  />
                </label>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  render() {
    const questionIndex = this.props.id;
    const component_strings = this.props.component_strings;

    return (
      <div className="cell-culture-interaction">
        <h4 style={{ marginTop: 0 }}>
          <FormattedMessage
            id={this.props.heading}
            defaultMessage={this.props.heading}
            description=""
          />
        </h4>
        <p>
          <FormattedMessage
            id={this.props.description}
            defaultMessage={this.props.description}
            description=""
          />
        </p>
        <div className="cell-culture-interaction__content">
          <div className="cell-culture-interaction__content--left">
            <h4>
              <FormattedMessage
                id={component_strings.description_heading}
                defaultMessage={component_strings.description_heading}
                description=""
              />
            </h4>
            {this.renderOptions(this.props.choices, questionIndex, "choices")}
          </div>
          <div className="cell-culture-interaction__content--right">
            <h4>
              <FormattedMessage
                id={component_strings.reasons_heading}
                defaultMessage={component_strings.reasons_heading}
                description=""
              />
            </h4>
            {this.renderOptions(this.props.reasons, questionIndex, "reasons")}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    selected_choices: state.matchingQuestion.choices.index,
    selected_reasons: state.matchingQuestion.reasons.index,
  };
};

export default connect(mapStateToProps, {
  setMatchingQuestionResponse,
})(injectIntl(MatchingQuestion));
